import {
  AcademicCapIcon,
  CloudArrowUpIcon,
  SwatchIcon,
  UserGroupIcon,
} from "@heroicons/react/24/outline";

const features = [
  {
    name: "Involvment",
    description:
      "Currently working as a Web Designer at Delv Pty Ltd, responsible for designing and implementing websites layout, interactive components and responsive design to enhance user experience across various platforms.",
    icon: CloudArrowUpIcon,
  },
  {
    name: "Collaboration",
    description:
      "Proven track record of successful remote collaborations, having worked with various teams at Delv, working on different projects for nearly 3 years.",
    icon: UserGroupIcon,
  },
  {
    name: "Creativity & Resourcefulness",
    description:
      "Coming up with ideas to improve processes or products and looking out for software and products to enhance the productivity of the whole team. ",
    icon: AcademicCapIcon,
  },
  {
    name: "Flexibility",
    description:
      "Adaptable to both remote and on-site work environments, with a strong focus on delivering high-quality Web Design & Front end solutions.",
    icon: SwatchIcon,
  },
];

export function Highlight() {
  return (
    <div className="bg-white py-10">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:text-center">
          <h2 className="text-2xl font-semibold leading-7 text-indigo-600">
            Professional Highlight
          </h2>
        </div>
        <div className="mx-auto mt-6 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-4xl">
          <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-10 lg:max-w-none lg:grid-cols-2 lg:gap-y-16">
            {features.map((feature) => (
              <div key={feature.name} className="relative pl-16">
                <dt className="text-base font-semibold leading-7 text-gray-900">
                  <div className="absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-lg bg-indigo-600">
                    <feature.icon
                      aria-hidden="true"
                      className="h-6 w-6 text-white"
                    />
                  </div>
                  {feature.name}
                </dt>
                <dd className="mt-2 text-base leading-7 text-gray-600">
                  {feature.description}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
  );
}
